// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/dashboard.css */
:root {
  --bg: #0b0d12;
  --card: #11141b;
  --card-2: #0f1218;
  --text: #e7edf6;
  --muted: #a6b0c3;
  --border: #1c2330;
  --brand: #22c55e;
  --brand-2: #16a34a;
  --danger: #ef4444;
  --warning: #f59e0b;
  --info: #3b82f6;
  --live: #f43f5e;
  --success: #10b981;

  --radius: 16px;
  --radius-sm: 12px;
  --shadow: 0 8px 24px rgba(0,0,0,0.35);
  --shadow-soft: 0 6px 18px rgba(0,0,0,0.25);

  --gap: 16px;
  --gap-lg: 24px;

  /* altura do header (Menu) */
  --menu-h: 72px;
}

* { box-sizing: border-box; }

/* Essentials para mobile: previne rolagem lateral */
html, body, #root { height: 100%; }
html, body {
  width: 100%;
  overflow-x: hidden;         /* <<< sem barra horizontal */
  -webkit-text-size-adjust: 100%;
}
img, svg, video {
  max-width: 100%;
  height: auto;
}

body {
  margin: 0;
  background: linear-gradient(180deg, #0a0c10 0%, #0b0d12 100%);
  color: var(--text);
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Inter, "Helvetica Neue", Arial, "Noto Sans";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Reserva espaço do header fixo (topbar) */
.topbar {
  position: fixed;
  top: 0; left: 0; right: 0;
  height: var(--menu-h);
  z-index: 60;
  background: var(--bg);
  border-bottom: 1px solid var(--border);
  display: grid;
  align-items: center;
}

.dashboard {
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr;
  padding-top: calc(var(--menu-h) + env(safe-area-inset-top)); /* safe-area iOS */
  width: 100%;
}

.dashboard-content {
  padding: 16px clamp(12px, 4vw, 32px);  /* mais compacto no mobile */
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

/* Header/KPIs */
.dash-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--gap-lg);
  margin-bottom: 28px;
  flex-wrap: wrap;              /* <<< quebra no mobile */
  min-width: 0;                 /* <<< permite encolher sem vazar */
}
.dash-title {
  font-size: clamp(20px, 4vw, 28px);
  margin: 0 0 4px 0;
  font-weight: 800;
  letter-spacing: 0.2px;
}
.dash-subtitle {
  margin: 0;
  color: var(--muted);
  font-size: 14px;
}
.dash-kpis {
  display: flex;
  gap: var(--gap);
  flex-wrap: wrap;             /* <<< evita overflow */
  justify-content: flex-start;
}
.kpi-card {
  background: linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 12px 14px;
  box-shadow: var(--shadow-soft);
  flex: 1 1 120px;             /* <<< encolhe bem no mobile */
  min-width: 120px;
}
.kpi-label { font-size: 12px; color: var(--muted); margin-bottom: 6px; }
.kpi-value { font-size: 22px; font-weight: 800; }

/* Grid principal */
.dashboard-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--gap-lg);
  min-width: 0;                 /* <<< previne vazamentos horizontais */
}
@media (min-width: 960px) {
  .dashboard-grid { grid-template-columns: 1fr 1fr; }
}

/* Cards genéricos */
.dashboard-card {
  background: linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;               /* -2px para mobile mais justo */
  box-shadow: var(--shadow);
  min-width: 0;                /* <<< importante para grids/flex */
}
.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  gap: 10px;
}
.card-head h2 {
  margin: 0;
  font-size: 18px;
  letter-spacing: 0.2px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;     /* <<< títulos longos não estouram */
}

/* Lista de cards (peladas) */
.cards-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--gap);
  min-width: 0;
}
@media (min-width: 760px) {
  .cards-container { grid-template-columns: 1fr 1fr; }
}

.pelada-card {
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
  background:
    radial-gradient(1200px 400px at 100% -20%, rgba(34,197,94,0.08), transparent),
    radial-gradient(800px 300px at -20% 110%, rgba(59,130,246,0.06), transparent),
    var(--card);
  box-shadow: var(--shadow-soft);
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;                /* <<< evita overflow dentro do grid */
}

.pelada-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;             /* <<< status + título quebram no mobile */
  min-width: 0;
}
.pelada-title {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.pelada-info {
  display: grid;
  gap: 10px;
  min-width: 0;
}

/* Troca row flex por grid para não estourar no mobile */
.info-row {
  display: grid;
  grid-template-columns: auto 1fr;  /* rótulo compacto + valor que cresce */
  align-items: start;
  gap: 10px;
  min-width: 0;
}
.info-label {
  color: var(--muted);
  font-size: 12px;
  white-space: nowrap;
}
.info-value {
  font-size: 14px;
  text-align: right;
  overflow-wrap: anywhere;     /* <<< quebra endereços/strings longas */
  word-break: break-word;
}
.info-value .muted {
  color: var(--muted);
  margin-left: 6px;
  font-size: 12px;
  white-space: nowrap;
}

/* Badges (status) */
.badge {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 12px; font-weight: 700;
  padding: 6px 10px; border-radius: 999px;
  border: 1px solid var(--border); background: #0c0f14;
  max-width: 100%;
  overflow: hidden; text-overflow: ellipsis;
}
.badge::before { content: ""; width: 8px; height: 8px; border-radius: 10px; display: inline-block; }

.badge--open { color: #22c55e; background: rgba(34,197,94,0.12); border-color: rgba(34,197,94,0.22); }
.badge--open::before { background: var(--brand); }

.badge--closed { color: #f59e0b; background: rgba(245,158,11,0.12); border-color: rgba(245,158,11,0.22); }
.badge--closed::before { background: var(--warning); }

.badge--scheduled { color: #3b82f6; background: rgba(59,130,246,0.12); border-color: rgba(59,130,246,0.22); }
.badge--scheduled::before { background: var(--info); }

.badge--live { color: #f43f5e; background: rgba(244,63,94,0.12); border-color: rgba(244,63,94,0.22); }
.badge--live::before { background: var(--live); }

.badge--finished { color: #9ca3af; background: rgba(156,163,175,0.12); border-color: rgba(156,163,175,0.22); }
.badge--finished::before { background: #9ca3af; }

.badge--canceled { color: #ef4444; background: rgba(239,68,68,0.12); border-color: rgba(239,68,68,0.22); }
.badge--canceled::before { background: var(--danger); }

.badge--none, .badge--unknown {
  color: #94a3b8; background: rgba(148,163,184,0.1); border-color: rgba(148,163,184,0.2);
}
.badge--none::before, .badge--unknown::before { background: #94a3b8; }

/* Buttons */
.button-group {
  margin-top: 6px;
  display: flex; gap: 10px; flex-wrap: wrap;
}
.btn {
  border: 1px solid var(--border);
  background: #0c0f14;
  color: var(--text);
  padding: 10px 12px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all .2s ease;
}
.btn:hover { transform: translateY(-1px); box-shadow: var(--shadow-soft); }
.btn--primary {
  background: linear-gradient(180deg, var(--brand) 0%, var(--brand-2) 100%);
  border: none; color: #041107;
}
.btn--primary:hover { filter: brightness(1.05); }
.btn--ghost { background: transparent; border: 1px solid var(--border); }

/* Loader */
.loader-overlay {
  position: fixed; inset: 0;
  background: rgba(6, 8, 12, 0.6);
  backdrop-filter: blur(3px);
  display: grid; place-items: center;
  z-index: 80;
}
.loader-spinner {
  width: 44px; height: 44px; border-radius: 999px;
  border: 3px solid #1f2937; border-top-color: var(--brand);
  animation: spin 1s linear infinite; margin-bottom: 10px;
}
.loader-text { text-align: center; color: var(--muted); }
@keyframes spin { to { transform: rotate(360deg); } }

/* Empty state */
.empty-state {
  border: 1px dashed var(--border);
  border-radius: var(--radius);
  background: #0c0f14;
  padding: 22px; text-align: center; color: var(--muted);
}
.empty-emoji { font-size: 28px; margin-bottom: 8px; }
.empty-title { font-weight: 800; color: var(--text); margin-bottom: 4px; }
.empty-subtitle { font-size: 13px; }

/* Errors */
.error-message {
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #fecaca;
  padding: 12px 14px;
  border-radius: var(--radius-sm);
  margin-bottom: 16px;
}

/* A11y */
button:focus-visible, .btn:focus-visible {
  outline: 2px solid var(--info);
  outline-offset: 2px;
}

/* Micro-ajustes para telas muito estreitas */
@media (max-width: 380px) {
  .dash-kpis { gap: 8px; }
  .kpi-card { flex: 1 1 110px; min-width: 110px; padding: 10px 12px; }
  .pelada-title { font-size: 15px; }
  .btn { padding: 9px 10px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;;EAElB,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;;EAE1C,WAAW;EACX,cAAc;;EAEd,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B,oDAAoD;AACpD,oBAAoB,YAAY,EAAE;AAClC;EACE,WAAW;EACX,kBAAkB,UAAU,6BAA6B;EACzD,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,kBAAkB;EAClB,mHAAmH;EACnH,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,4BAA4B;EAC5B,2DAA2D,EAAE,kBAAkB;EAC/E,WAAW;AACb;;AAEA;EACE,oCAAoC,GAAG,4BAA4B;EACnE,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe,eAAe,yBAAyB;EACvD,YAAY,kBAAkB,mCAAmC;AACnE;AACA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,eAAe,cAAc,uBAAuB;EACpD,2BAA2B;AAC7B;AACA;EACE,uEAAuE;EACvE,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe,cAAc,8BAA8B;EAC3D,gBAAgB;AAClB;AACA,aAAa,eAAe,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACvE,aAAa,eAAe,EAAE,gBAAgB,EAAE;;AAEhD,mBAAmB;AACnB;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY,kBAAkB,uCAAuC;AACvE;AACA;EACE,kBAAkB,8BAA8B,EAAE;AACpD;;AAEA,oBAAoB;AACpB;EACE,uEAAuE;EACvE,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa,gBAAgB,gCAAgC;EAC7D,yBAAyB;EACzB,YAAY,iBAAiB,mCAAmC;AAClE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB,MAAM,oCAAoC;AACnE;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,YAAY;AACd;AACA;EACE,mBAAmB,8BAA8B,EAAE;AACrD;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb;;;eAGa;EACb,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY,iBAAiB,sCAAsC;AACrE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe,cAAc,0CAA0C;EACvE,YAAY;AACd;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,+BAA+B,GAAG,uCAAuC;EACzE,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB,MAAM,wCAAwC;EACrE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,eAAe,EAAE,gBAAgB;EACjC,iBAAiB,EAAE,oBAAoB;EACvC,+BAA+B,EAAE,mBAAmB;EACpD,eAAe;EACf,gBAAgB,EAAE,uBAAuB;AAC3C;AACA,iBAAiB,WAAW,EAAE,UAAU,EAAE,WAAW,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AAEnG,eAAe,cAAc,EAAE,gCAAgC,EAAE,kCAAkC,EAAE;AACrG,uBAAuB,wBAAwB,EAAE;;AAEjD,iBAAiB,cAAc,EAAE,iCAAiC,EAAE,mCAAmC,EAAE;AACzG,yBAAyB,0BAA0B,EAAE;;AAErD,oBAAoB,cAAc,EAAE,iCAAiC,EAAE,mCAAmC,EAAE;AAC5G,4BAA4B,uBAAuB,EAAE;;AAErD,eAAe,cAAc,EAAE,gCAAgC,EAAE,kCAAkC,EAAE;AACrG,uBAAuB,uBAAuB,EAAE;;AAEhD,mBAAmB,cAAc,EAAE,kCAAkC,EAAE,oCAAoC,EAAE;AAC7G,2BAA2B,mBAAmB,EAAE;;AAEhD,mBAAmB,cAAc,EAAE,gCAAgC,EAAE,kCAAkC,EAAE;AACzG,2BAA2B,yBAAyB,EAAE;;AAEtD;EACE,cAAc,EAAE,iCAAiC,EAAE,mCAAmC;AACxF;AACA,gDAAgD,mBAAmB,EAAE;;AAErE,YAAY;AACZ;EACE,eAAe;EACf,aAAa,EAAE,SAAS,EAAE,eAAe;AAC3C;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;AACA,aAAa,2BAA2B,EAAE,8BAA8B,EAAE;AAC1E;EACE,yEAAyE;EACzE,YAAY,EAAE,cAAc;AAC9B;AACA,sBAAsB,wBAAwB,EAAE;AAChD,cAAc,uBAAuB,EAAE,+BAA+B,EAAE;;AAExE,WAAW;AACX;EACE,eAAe,EAAE,QAAQ;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa,EAAE,mBAAmB;EAClC,WAAW;AACb;AACA;EACE,WAAW,EAAE,YAAY,EAAE,oBAAoB;EAC/C,yBAAyB,EAAE,8BAA8B;EACzD,kCAAkC,EAAE,mBAAmB;AACzD;AACA,eAAe,kBAAkB,EAAE,mBAAmB,EAAE;AACxD,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,gBAAgB;AAChB;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa,EAAE,kBAAkB,EAAE,mBAAmB;AACxD;AACA,eAAe,eAAe,EAAE,kBAAkB,EAAE;AACpD,eAAe,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AACzE,kBAAkB,eAAe,EAAE;;AAEnC,WAAW;AACX;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,aAAa,QAAQ,EAAE;EACvB,YAAY,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;EACnE,gBAAgB,eAAe,EAAE;EACjC,OAAO,iBAAiB,EAAE;AAC5B","sourcesContent":["/* src/pages/dashboard.css */\n:root {\n  --bg: #0b0d12;\n  --card: #11141b;\n  --card-2: #0f1218;\n  --text: #e7edf6;\n  --muted: #a6b0c3;\n  --border: #1c2330;\n  --brand: #22c55e;\n  --brand-2: #16a34a;\n  --danger: #ef4444;\n  --warning: #f59e0b;\n  --info: #3b82f6;\n  --live: #f43f5e;\n  --success: #10b981;\n\n  --radius: 16px;\n  --radius-sm: 12px;\n  --shadow: 0 8px 24px rgba(0,0,0,0.35);\n  --shadow-soft: 0 6px 18px rgba(0,0,0,0.25);\n\n  --gap: 16px;\n  --gap-lg: 24px;\n\n  /* altura do header (Menu) */\n  --menu-h: 72px;\n}\n\n* { box-sizing: border-box; }\n\n/* Essentials para mobile: previne rolagem lateral */\nhtml, body, #root { height: 100%; }\nhtml, body {\n  width: 100%;\n  overflow-x: hidden;         /* <<< sem barra horizontal */\n  -webkit-text-size-adjust: 100%;\n}\nimg, svg, video {\n  max-width: 100%;\n  height: auto;\n}\n\nbody {\n  margin: 0;\n  background: linear-gradient(180deg, #0a0c10 0%, #0b0d12 100%);\n  color: var(--text);\n  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Inter, \"Helvetica Neue\", Arial, \"Noto Sans\";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Reserva espaço do header fixo (topbar) */\n.topbar {\n  position: fixed;\n  top: 0; left: 0; right: 0;\n  height: var(--menu-h);\n  z-index: 60;\n  background: var(--bg);\n  border-bottom: 1px solid var(--border);\n  display: grid;\n  align-items: center;\n}\n\n.dashboard {\n  min-height: 100vh;\n  display: grid;\n  grid-template-rows: auto 1fr;\n  padding-top: calc(var(--menu-h) + env(safe-area-inset-top)); /* safe-area iOS */\n  width: 100%;\n}\n\n.dashboard-content {\n  padding: 16px clamp(12px, 4vw, 32px);  /* mais compacto no mobile */\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* Header/KPIs */\n.dash-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--gap-lg);\n  margin-bottom: 28px;\n  flex-wrap: wrap;              /* <<< quebra no mobile */\n  min-width: 0;                 /* <<< permite encolher sem vazar */\n}\n.dash-title {\n  font-size: clamp(20px, 4vw, 28px);\n  margin: 0 0 4px 0;\n  font-weight: 800;\n  letter-spacing: 0.2px;\n}\n.dash-subtitle {\n  margin: 0;\n  color: var(--muted);\n  font-size: 14px;\n}\n.dash-kpis {\n  display: flex;\n  gap: var(--gap);\n  flex-wrap: wrap;             /* <<< evita overflow */\n  justify-content: flex-start;\n}\n.kpi-card {\n  background: linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 12px 14px;\n  box-shadow: var(--shadow-soft);\n  flex: 1 1 120px;             /* <<< encolhe bem no mobile */\n  min-width: 120px;\n}\n.kpi-label { font-size: 12px; color: var(--muted); margin-bottom: 6px; }\n.kpi-value { font-size: 22px; font-weight: 800; }\n\n/* Grid principal */\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--gap-lg);\n  min-width: 0;                 /* <<< previne vazamentos horizontais */\n}\n@media (min-width: 960px) {\n  .dashboard-grid { grid-template-columns: 1fr 1fr; }\n}\n\n/* Cards genéricos */\n.dashboard-card {\n  background: linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 16px;               /* -2px para mobile mais justo */\n  box-shadow: var(--shadow);\n  min-width: 0;                /* <<< importante para grids/flex */\n}\n.card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n  gap: 10px;\n}\n.card-head h2 {\n  margin: 0;\n  font-size: 18px;\n  letter-spacing: 0.2px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;     /* <<< títulos longos não estouram */\n}\n\n/* Lista de cards (peladas) */\n.cards-container {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--gap);\n  min-width: 0;\n}\n@media (min-width: 760px) {\n  .cards-container { grid-template-columns: 1fr 1fr; }\n}\n\n.pelada-card {\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 16px;\n  background:\n    radial-gradient(1200px 400px at 100% -20%, rgba(34,197,94,0.08), transparent),\n    radial-gradient(800px 300px at -20% 110%, rgba(59,130,246,0.06), transparent),\n    var(--card);\n  box-shadow: var(--shadow-soft);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;                /* <<< evita overflow dentro do grid */\n}\n\n.pelada-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;             /* <<< status + título quebram no mobile */\n  min-width: 0;\n}\n.pelada-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 800;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.pelada-info {\n  display: grid;\n  gap: 10px;\n  min-width: 0;\n}\n\n/* Troca row flex por grid para não estourar no mobile */\n.info-row {\n  display: grid;\n  grid-template-columns: auto 1fr;  /* rótulo compacto + valor que cresce */\n  align-items: start;\n  gap: 10px;\n  min-width: 0;\n}\n.info-label {\n  color: var(--muted);\n  font-size: 12px;\n  white-space: nowrap;\n}\n.info-value {\n  font-size: 14px;\n  text-align: right;\n  overflow-wrap: anywhere;     /* <<< quebra endereços/strings longas */\n  word-break: break-word;\n}\n.info-value .muted {\n  color: var(--muted);\n  margin-left: 6px;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n/* Badges (status) */\n.badge {\n  display: inline-flex; align-items: center; gap: 6px;\n  font-size: 12px; font-weight: 700;\n  padding: 6px 10px; border-radius: 999px;\n  border: 1px solid var(--border); background: #0c0f14;\n  max-width: 100%;\n  overflow: hidden; text-overflow: ellipsis;\n}\n.badge::before { content: \"\"; width: 8px; height: 8px; border-radius: 10px; display: inline-block; }\n\n.badge--open { color: #22c55e; background: rgba(34,197,94,0.12); border-color: rgba(34,197,94,0.22); }\n.badge--open::before { background: var(--brand); }\n\n.badge--closed { color: #f59e0b; background: rgba(245,158,11,0.12); border-color: rgba(245,158,11,0.22); }\n.badge--closed::before { background: var(--warning); }\n\n.badge--scheduled { color: #3b82f6; background: rgba(59,130,246,0.12); border-color: rgba(59,130,246,0.22); }\n.badge--scheduled::before { background: var(--info); }\n\n.badge--live { color: #f43f5e; background: rgba(244,63,94,0.12); border-color: rgba(244,63,94,0.22); }\n.badge--live::before { background: var(--live); }\n\n.badge--finished { color: #9ca3af; background: rgba(156,163,175,0.12); border-color: rgba(156,163,175,0.22); }\n.badge--finished::before { background: #9ca3af; }\n\n.badge--canceled { color: #ef4444; background: rgba(239,68,68,0.12); border-color: rgba(239,68,68,0.22); }\n.badge--canceled::before { background: var(--danger); }\n\n.badge--none, .badge--unknown {\n  color: #94a3b8; background: rgba(148,163,184,0.1); border-color: rgba(148,163,184,0.2);\n}\n.badge--none::before, .badge--unknown::before { background: #94a3b8; }\n\n/* Buttons */\n.button-group {\n  margin-top: 6px;\n  display: flex; gap: 10px; flex-wrap: wrap;\n}\n.btn {\n  border: 1px solid var(--border);\n  background: #0c0f14;\n  color: var(--text);\n  padding: 10px 12px;\n  border-radius: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all .2s ease;\n}\n.btn:hover { transform: translateY(-1px); box-shadow: var(--shadow-soft); }\n.btn--primary {\n  background: linear-gradient(180deg, var(--brand) 0%, var(--brand-2) 100%);\n  border: none; color: #041107;\n}\n.btn--primary:hover { filter: brightness(1.05); }\n.btn--ghost { background: transparent; border: 1px solid var(--border); }\n\n/* Loader */\n.loader-overlay {\n  position: fixed; inset: 0;\n  background: rgba(6, 8, 12, 0.6);\n  backdrop-filter: blur(3px);\n  display: grid; place-items: center;\n  z-index: 80;\n}\n.loader-spinner {\n  width: 44px; height: 44px; border-radius: 999px;\n  border: 3px solid #1f2937; border-top-color: var(--brand);\n  animation: spin 1s linear infinite; margin-bottom: 10px;\n}\n.loader-text { text-align: center; color: var(--muted); }\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* Empty state */\n.empty-state {\n  border: 1px dashed var(--border);\n  border-radius: var(--radius);\n  background: #0c0f14;\n  padding: 22px; text-align: center; color: var(--muted);\n}\n.empty-emoji { font-size: 28px; margin-bottom: 8px; }\n.empty-title { font-weight: 800; color: var(--text); margin-bottom: 4px; }\n.empty-subtitle { font-size: 13px; }\n\n/* Errors */\n.error-message {\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #fecaca;\n  padding: 12px 14px;\n  border-radius: var(--radius-sm);\n  margin-bottom: 16px;\n}\n\n/* A11y */\nbutton:focus-visible, .btn:focus-visible {\n  outline: 2px solid var(--info);\n  outline-offset: 2px;\n}\n\n/* Micro-ajustes para telas muito estreitas */\n@media (max-width: 380px) {\n  .dash-kpis { gap: 8px; }\n  .kpi-card { flex: 1 1 110px; min-width: 110px; padding: 10px 12px; }\n  .pelada-title { font-size: 15px; }\n  .btn { padding: 9px 10px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
